<template>
  <v-app style="background-color: #f8f9fa;">
    <v-app-bar app color="#551ebb" dark elevation="1">
  <v-container class="d-flex align-center justify-center pa-0" style="max-width: 1200px;">
    <v-img
      alt="Leva Já"
      contain
      src="@/assets/logo.png"
      max-height="40"
      max-width="150"
    />
  </v-container>
</v-app-bar>

    <v-main>
      <v-container class="pt-10 pb-16" style="max-width: 1200px;">
        
        <!-- Cabeçalho da Página -->
        <div class="text-center mb-10">
          <h1 class="text-h3 font-weight-bold mb-3" style="color: #2c3e50;">
            Gerador de Campanhas
          </h1>
          <p class="text-subtitle-1 grey--text text--darken-1">
            Crie material de divulgação para as suas redes sociais em segundos.
          </p>
        </div>

        <!-- Área de Upload e Recorte -->
        <v-row>
          <v-col cols="12" md="5" class="d-flex flex-column">
            <v-card elevation="2" class="pa-6 rounded-lg flex-grow-1">
              <div class="d-flex align-center mb-6">
                <v-avatar color="#551ebb" size="36" class="mr-3">
                  <span class="white--text font-weight-bold">1</span>
                </v-avatar>
                <h2 class="text-h6 font-weight-bold mb-0" style="color: #2c3e50;">
                  Envie o logótipo
                </h2>
              </div>
              <Uploader />
            </v-card>
          </v-col>
          
          <v-col cols="12" md="7" class="d-flex flex-column">
            <v-card elevation="2" class="pa-6 rounded-lg flex-grow-1">
              <div class="d-flex align-center mb-6">
                <v-avatar color="#551ebb" size="36" class="mr-3">
                  <span class="white--text font-weight-bold">2</span>
                </v-avatar>
                <h2 class="text-h6 font-weight-bold mb-0" style="color: #2c3e50;">
                  Ajuste o recorte
                </h2>
              </div>
              <ImageCrop />
            </v-card>
          </v-col>
        </v-row>

        <v-divider class="my-12"></v-divider>

        <!-- Área de Resultados -->
        <div class="d-flex align-center mb-6">
          <v-avatar color="#551ebb" size="36" class="mr-3">
            <span class="white--text font-weight-bold">3</span>
          </v-avatar>
          <div>
            <h2 class="text-h5 font-weight-bold mb-0" style="color: #2c3e50;">
              Imagens Geradas
            </h2>
            <p class="text-body-2 grey--text mt-1 mb-0">
              Selecione as peças que deseja transferir.
            </p>
          </div>
        </div>
        
        <v-card elevation="2" class="pa-6 rounded-lg">
          <Images />
        </v-card>

      </v-container>
    </v-main>
  </v-app>
</template>

<script>
  import Uploader from './components/Uploader';
  import ImageCrop from './components/ImageCrop';
  import Images from './components/Images';

  export default {
    name: 'App',
    components: {
      Uploader,
      ImageCrop,
      Images,
    },
    created() {
      document.title = "Leva Já Imagens"
    }       
  };
</script>

<style>
  html {
    overflow-y: auto;
  }
  .v-main {
    transition: all 0.3s ease;
  }
</style>